export const SOP_ENDPOINTS = {
  FETCH_ISSUES: 'admin/sops/issues',
  FETCH: 'admin/sops/fetch',
  CREATE_OR_UPDATE: 'admin/sops/create_or_update',
  DELETE: 'admin/sops/delete',
};

export const SOP_QUERY_PARAMS = {
  PID: 'pid',
  ISSUE: 'issue',
  SUB_ISSUE: 'sub_issue',
};

export const isEditorEmpty = (value) => {
  if (!value) return true;
  return value.replace(/<[^>]*>/g, '').trim().length === 0;
};

export const SOP_STATUS = {
  NONE: 'NONE',
  FOUND: 'FOUND',
  NOT_FOUND: 'NOT_FOUND',
};

export const SKELETON_ROWS = [
  { cols: 1, height: '2.4rem', width: '200px' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
  { cols: 2, height: '1.8rem' },
];
